export const innerTextStyle = {
    fontFamily: "Inter",	
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.03em",
    textAlign: "center"
};
